// Promise-based setTimeout: resolves after `ms` milliseconds. No cancellation,
// no rejection — the timer always runs to completion.
export function sleep(ms: number): Promise<void> {
  return new Promise<void>((res) => setTimeout(res, ms));
}
